<h2 mat-dialog-title>{{ type === 'warn' ? 'Error' : message }}</h2>
<div mat-dialog-content class="dialog-content">
  {{ type === 'warn' ? message : helpText }}
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="dialogRef.close()">
    {{ 'OK' | translate }}
  </button>
</div>
